<!--
  -
  -  Filename........: ProductAttributes.vue
  -  Project.........: logistik.app
  -  @copyright......: YBM Deutschland Andy Puderbach und Stephan Wienczny GBR
  -  @link...........: https://www.ybm-deutschland.de/
  -  @version........: 1.0
  -
  -  @since..........: 27.04.20, 14:30
  -  @author.........: Alexander Helmich
  -
  -  @brief..........: vue component to add into the product vue
  -
  -->

<template>
    <div class="col-md-12">
        <h3>{{ $t('page.product.view.media_assets.assets_header')}}</h3>
        <div class="row">
            <h2>{{ $t('page.product.view.media_assets.images_header')}}</h2>
            <div class="col-md-12" :key="rerender">
                <div class="panel panel-default mb-4" v-for="(image, index ) in images">
                    <div class="panel-body">
                        <div class="row">
                            <div class="col-md-4">
                                <img
                                        class="previewer-img img-thumbnail p-3"
                                        :src="image.src"
                                        alt=""
                                        @click="show(index)"
                                />
                                <vuePicturePreview ref="previewer" :list="images" :options="options"></vuePicturePreview>
                            </div>
                            <div class="col-md-6">
                                <label :for="'otto_image_name_' + index">{{$t('page.product.view.media_assets.name')}}</label><input type="text" :id="'otto_image_name_' + index" :name="'otto_image_name_' + index" class="form-control" v-model="image.name" />
                                <label :for="'otto_image_url_' + index">{{$t('page.product.view.media_assets.image')}}</label><input type="text" :id="'otto_image_url_' + index" :name="'otto_image_url_' + index" class="form-control" v-model="image.src" v-on:change="getImageBounds(index, image)" />
                                <label :for="'otto_image_width_' + index">{{$t('page.product.view.media_assets.image_width')}}</label><input type="text" :id="'otto_image_width_' + index" :name="'otto_image_width_' + index" class="form-control" v-model="image.w" />
                                <label :for="'otto_image_height_' + index">{{$t('page.product.view.media_assets.image_height')}}</label><input type="text" :id="'otto_image_height_' + index" :name="'otto_image_height_' + index" class="form-control" v-model="image.h" />
                            </div>
                            <div class="col-md-1 col-md-offset-1">
                                <button type='button' class='form-control glyphicon glyphicon-remove' v-on:click="deleteImage(index)"></button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-md-3">
                    <button class="btn btn-primary form-control ml-4" v-on:click="addImage">{{$t('page.product.view.media_assets.add_image')}}</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import vuePicturePreview from 'vue-picture-preview'

    export default {
        name: "ProductMediaAssets",
        components: {
            vuePicturePreview,
        },
        data: function() {
            return {
                images: this.value,
                productId: -1,
                rerender: 0,

                options: {
                    getThumbBoundsFn(index) {
                        // find thumbnail element
                        let thumbnail = document.querySelectorAll('.previewer-img')[
                            index
                            ];
                        // get window scroll Y
                        let pageYScroll =
                            window.pageYOffset || document.documentElement.scrollTop;
                        // optionally get horizontal scroll
                        // get position of element relative to viewport
                        let rect = thumbnail.getBoundingClientRect();
                        // w = width
                        return { x: rect.left, y: rect.top + pageYScroll, w: rect.width };
                        // Good guide on how to get element coordinates:
                        // http://javascript.info/tutorial/coordinates
                    }
                }
            }
        },
        props: {
            value: Array
        },
        methods: {
            setMediaAssets: function (images) {
                this.productId = id;

                this.productData = [];
                images.forEach(function (image) {
                     This.productData.images.push({
                         name: image.name,
                         src: image.src,
                         msrc: image.msrc,
                         w: image.w,
                         h: image.h,
                     });
                 })
            },
            getMediaAssets: function () {
                return this.images;
            },
            addImage: function () {
                this.images.push({
                    name: "Image_" + this.images.length,
                    src: "",
                    msrc: "",
                    w: 0,
                    h: 0
                });

            },
            deleteImage: function(index){
                this.images.splice(index, 1);
                this.rerender++;
            },
            getImageBounds: function(index, image){
                let img = new Image();
                let vue = image;
                img.onload = function(){
                    console.log(this.width + 'x' + this.height);
                    vue.w = this.width;
                    vue.h = this.height;
                }
                img.src = image.src;

            },
            show: function (index) {
                this.$refs.previewer[index].show(index);
            }
        },
        watch: {
            value: function (newValue, oldValue) {
                this.images = newValue;
            },
            images: function (newValue, oldValue) {
                this.$emit('input', newValue);
            }
        }
    }
</script>
<style scoped lang="scss">
    .previewer-img{
        max-width: 75%;
    }
</style>